import '../svg-icon/svg-icon';

import { html, LitElement, PropertyValues, TemplateResult } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

type TypeOption = 'action' | 'link';

@customElement('button-input')
export class ButtonInput extends LitElement {

    // Props

    @property({ type: Boolean, reflect: true })
    disabled: boolean = false;   

    @property({ type: Boolean, reflect: false })
    active: boolean = false;  
	
	@property({ type: String })
    icon: string = ''; 
    
    @property({ type: String })
    type: TypeOption = 'action';

    @property({ type: String })
    name: string = '';

    @property({ type: String })
    href?: string = undefined;

	@property({ type: String })
    target: string | null = null;

    @state()
    _label: string = '';

    // Lifecycle Hooks

    firstUpdated() {

        // class list
        this.classList.add('ButtonInput');

        // slots
        const slot: Element | null= this.querySelector('[slot="label"]');
		if (slot) {
			this._label = slot.innerHTML;
			slot.remove();
		}

		// event listener
        if (this.type == 'link') {
            this.addEventListener('click', () => {
                if (this.target === '_blank') {
					window.open(this.href ?? '', '_blank');
				} else {
					window.location.href = this.href ?? '';
				}
            });
        }

    }

    updated(changedProperties: PropertyValues) {
        if (changedProperties.has('active')) {
            this.classList.toggle('is-active', this.active);
        }
    }

    // Render

    render() {
        return html`
            ${ (this.type == 'action') ? this.actionTemplate() : '' }
            ${ (this.type == 'link') ? this.linkTemplate() : '' }
        `;
    }

    createRenderRoot() { 
        return this;
    }

    // Templates

    actionTemplate(): TemplateResult {
        return html`
            <button 
                class="ButtonInput-button"
                type="button"
                data-name="${ this.name.replaceAll('-',' ') }"
				aria-label="${ this.name.replaceAll('-',' ') }"
                @click="${ (e: Event) => e.preventDefault() }">
				${ this.icon ? this.iconTemplate() : '' }
                ${ unsafeHTML(this._label) }
            </button>
        `;
    }

    linkTemplate(): TemplateResult {
        return html`
            <a 
                class="ButtonInput-link"
                href="${ this.href ?? '' }"
                data-name="${ this.name }"
				target="${ this.target ?? '_self' }"
				@click="${ (e: Event) => e.preventDefault() }">
				${ this.icon ? this.iconTemplate() : '' }
                ${ unsafeHTML(this._label) }
            </a>
        `;
    }

	iconTemplate(): TemplateResult {
        return html`
			<svg-icon name="${ this.icon }"></svg-icon>
		`;
    }

}